'use client'

import type { PropsWithChildren } from 'react'

import { Text } from '../../text'

export const ConfirmationModalText = ({ children }: PropsWithChildren) => {
  return (
    <span className="flex text-left">
      <Text fontSize="sm" textColor="secondary">
        {children}
      </Text>
    </span>
  )
}
